import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const StandardNotificationMessage = styled(Typography)<{component: "h4"}>`
    && {
        font-family: ${({theme}) => theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        font-weight: ${({theme}) => theme.uxfabric.global.body1.fontWeight};
        font-size: ${({theme}) => theme.uxfabric.global.body1.fontSize};
        padding: 0.8125rem 1.1875rem 0.75rem 1rem;
        width: 16rem;
        @media (max-width: ${breakpoints.values.md - 1}px) {
            width: 15rem;
        }
    }
`

export default StandardNotificationMessage
